import React, { useState } from "react";
import {
  CreditCard,
  Shield,
  FileText,
  LogOut,
  Bell,
  Info,
  Trash2,
} from "lucide-react";
import Payment from "./Payment/Payment";
import Credits from "./Credits/Credits";
import Security from "./Security/Security";
import Notification from "./Notification/Notification";
import DeleteAccount from "./DeleteAccount/DeleteAccount";
import Logout from "./Logout/Logout";
import TermService from "./TermService/TermService";
import PrivacyPolicy from "./PrivacyPolicy/PrivacyPolicy";
import AppVersion from "./AppVersion/AppVersion";

const Sidebar = () => {
  const [activeItem, setActiveItem] = useState("payments");
  const [showLogoutDialog, setShowLogoutDialog] = useState(false);

  const menuSections = [
    {
      items: [{ id: "payments", label: "Payments", Icon: CreditCard }],
    },
    {
      title: "Account",
      items: [{ id: "security", label: "Password & Security", Icon: Shield }],
    },
    {
      title: "Preferences",
      items: [{ id: "notifications", label: "Notifications", Icon: Bell }],
    },
    {
      title: "Legal",
      items: [
        { id: "privacy", label: "Privacy Policy", Icon: FileText },
        { id: "terms", label: "Terms of Service", Icon: FileText },
      ],
    },
    {
      title: "App Info",
      items: [{ id: "version", label: "App Version", Icon: Info }],
    },
    {
      title: "Account Management",
      items: [
        { id: "delete", label: "Delete your account", Icon: Trash2 },
        { id: "logout", label: "Logout", Icon: LogOut },
      ],
    },
  ];

  const contentMap = {
    payments: <Payment />,
    Credits: <Credits />,
    security: <Security />,
    notifications: <Notification />,
    privacy: <PrivacyPolicy />,
    terms: <TermService />,
   version: <AppVersion />,
    delete: <DeleteAccount />,
  };

  const handleViewDetails = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      <aside className="sidebarr">
        <div className="sidebar__header">
          <div className="sidebar__logo">
            {/* <div className="sidebar__logo-icon">
              <Home size={20} strokeWidth={2.5} />
            </div> */}
            <span className="sidebar__logo-text">Setting</span>
          </div>
        </div>

        <nav className="sidebar__nav">
          {menuSections.map((section) => (
            <div key={section.title} className="sidebar__section">
              <h4 className="sidebar__title">{section.title}</h4>
              <ul className="sidebar__menu">
                {section.items.map(({ id, label, Icon }) => (
                  <li
                    key={id}
                    className={`sidebar__item ${
                      activeItem === id ? "sidebar__item--active" : ""
                    }`}
                    onClick={() => {
                      if (id === "logout") {
                        setShowLogoutDialog(true);
                        return;
                      }
                      setActiveItem(id);
                      handleViewDetails();
                    }}
                    role="menuitem"
                    tabIndex={0}
                    onKeyPress={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        if (id === "logout") {
                          setShowLogoutDialog(true);
                          return;
                        }
                        setActiveItem(id);
                      }
                    }}
                  >
                    <Icon className="sidebar__icon" size={18} strokeWidth={2} />
                    <span className="sidebar__label">{label}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </nav>
      </aside>
      <main className="client-settings__main">
        {contentMap[activeItem] || (
          <h4 style={{ marginTop: "104px", fontSize: 20, color: "#4b5563" }}>
            Select a setting to view details.
          </h4>
        )}
      </main>

      {showLogoutDialog && (
        <Logout onCancel={() => setShowLogoutDialog(false)} />
      )}
    </>
  );
};

export default Sidebar;
